<template>
  <v-card>
    <v-card-title>
      <h2 class="text-h5" style="color: #ca0538">
        {{ $t("searchRules.values") }} :
      </h2>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('searchRules.search_substance_name')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="substances"
      :search="search"
      :items-per-page="5"
      :item-class="paddingTab"
    >
      <template v-slot:[`item.substance`]="{ item }">
        <v-container
          @click="goToSub(item.substance.id)"
          style="cursor: pointer"
        >
          <v-row class="my-1">
            <v-col>
              <v-row>
                <div class="text-body-1">{{ item.substance.name }}</div>
              </v-row>
              <v-row>
                <div class="mr-2 text-body-2">N°CE :</div>
                <div class="text-body-2">{{ item.substance.ce }}</div>
              </v-row>
              <v-row>
                <div class="mr-2 text-body-2">N°CAS :</div>
                <div class="text-body-2">{{ item.substance.cas }}</div>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template
        v-for="(header, i) in massiveHeaders"
        v-slot:[`item.${header}`]="{ item }"
      >
        <div :key="header + i">
          <div v-if="typeof item[header] === 'string'">
            <massive-item :valueItem="item[header]"></massive-item>
          </div>
        </div>
      </template>
      <template v-slot:[`footer.prepend`]>
        <div v-if="ruleModified">
          <ul class="my-2" style="list-style: none">
            <li>{{ $t("searchRules.ruleModified") }}</li>
            <li class="ml-2">
              <v-icon x-small color="blue"> mdi-square-rounded </v-icon>
              {{ $t("searchRules.newSub") }}
            </li>
            <li class="ml-2">
              <v-icon x-small color="green"> mdi-square-rounded </v-icon>
              {{ $t("searchRules.modifiedSub") }}
            </li>
          </ul>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<style>
.paddingTab td {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.newSub {
  color: #2196f3;
}

.modifiedSub {
  color: #4caf50;
}
</style>

<script>
import { mapGetters, mapMutations } from "vuex";
import MassiveItem from "./TableValueMassiveItem.vue";

export default {
  data() {
    return {
      search: "",
      dialog: false,
    };
  },
  computed: {
    ...mapGetters(["currentPage"]),
    ruleModified() {
      if (Object.keys(this.latestChanges).length) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapMutations(["setLastPage", "resetCurrentPage"]),
    paddingTab(item) {
      if (this.latestChanges) {
        if (this.latestChanges[item.substance.id]) {
          if (this.latestChanges[item.substance.id].change === "new") {
            return "newSub";
          }
          if (this.latestChanges[item.substance.id].change === "modified") {
            return "modifiedSub";
          }
        }
      }
      return "paddingTab";
    },
    goToSub(sub) {
      this.setLastPage(this.currentPage);
      this.resetCurrentPage();
      this.$router.push({
        name: "ShowSubstances",
        params: {
          id: sub,
          rule: {
            id: this.rulesItem._id,
            name: this.rulesItem.usual_name,
            origin: this.rulesItem.from,
          },
          theme: this.rulesItem.theme,
        },
      });
    },
  },
  props: {
    headers: Array,
    substances: Array,
    massiveHeaders: Array,
    latestChanges: Object,
    rulesItem: Object,
  },
  components: {
    MassiveItem,
  },
};
</script>